// extracted by mini-css-extract-plugin
export default {"form":"ReportProblemPopup_form__rtQw+","loaderWrapper":"ReportProblemPopup_loaderWrapper__PLkzs"};